module.exports = __webpack_public_path__ + "img/8.c50f4515.jpg";